import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetCashRechargeDetailsRequest, GetCashRechargeDetailsResponse } from '../../interface/CustomerRecharge';
import { ApiResponse } from '../../api/api';
import customerRechargeService from '../../services/customerRechargeService';
import { CUSTOMER_RECHARGE_ACTIONS } from '../../constant/stringConstant';

export type GetCashRechargeDetailsWithSignal = GetCashRechargeDetailsRequest & { signal?: AbortSignal };

export const fetchCashRechargeDetails = createAsyncThunk<
  ApiResponse<GetCashRechargeDetailsResponse>,
  GetCashRechargeDetailsWithSignal,
  { rejectValue: string }
>(
  CUSTOMER_RECHARGE_ACTIONS.FETCH_CASH_RECHARGE_DETAILS,
  async (request, { rejectWithValue }) => {
    try {
      return await customerRechargeService.getCashRechargeDetails(request, request.signal);
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface FetchCashRechargeDetailsState {
  cashRechargeDetails: ApiResponse<GetCashRechargeDetailsResponse> | null;
  loading: boolean;
  error: string | null;
}

const initialState: FetchCashRechargeDetailsState = {
  cashRechargeDetails: null,
  loading: false,
  error: null,
};

const fetchCashRechargeDetailsSlice = createSlice({
  name: 'fetchCashRechargeDetails',
  initialState,
  reducers: {
    resetCashRechargeDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCashRechargeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.cashRechargeDetails = null;
      })
      .addCase(fetchCashRechargeDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.cashRechargeDetails = {
          ...action.payload,
          Data: {
            ...action.payload.Data,
            DiscountId: action.payload.Data.DiscountId?action.payload.Data.DiscountId:0 , //  set to 0 if null, ignore payload.Data.DiscountId
          },
        };
      })
      .addCase(fetchCashRechargeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
        state.cashRechargeDetails = null;
      });
  },
});

export const { resetCashRechargeDetails } = fetchCashRechargeDetailsSlice.actions;
export default fetchCashRechargeDetailsSlice.reducer;
